<div class="service-viewer">
  <!-- Loading state for the entire container -->
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner-border text-primary">
      <span class="visually-hidden">{{ 'Loading' | translate }}</span>
    </div>
    <p class="mt-2">{{ 'Loading services...' | translate }}</p>
  </div>

  <!-- Services List -->
  <ng-container *ngIf="!isLoading">
    <ng-container
      *ngFor="
        let serviceField of visibleServiceFields;
        let i = index;
        let last = last
      ">
      <div class="service-section" [class.active]="expandedServices[i]">
        <!-- Service Header -->
        <div class="service-section-header">
          <div class="service-info">
            <div class="service-number">{{ i + 1 }}</div>
            <h3 class="service-title">
              {{ serviceField.props?.label || 'Service ' + (i + 1) }}
              <span
                class="optional-badge"
                *ngIf="serviceField.props?.['optional']">
                {{ 'Optional' | translate }}
              </span>
            </h3>
          </div>

          <div class="d-flex align-items-center gap-2">
            <!-- Edit button (when service is completed) -->
            <button
              *ngIf="completedServices[i] && !expandedServices[i]"
              type="button"
              class="edit-button"
              (click)="editService(i, $event)">
              <i class="icon-edit-05"></i> {{ 'Edit' | translate }}
            </button>

            <!-- Completion indicator -->
            <div
              class="completed-indicator"
              *ngIf="completedServices[i] && !expandedServices[i]">
              <i class="icon-check"></i>
            </div>

            <!-- Expand/collapse icon -->
            <button
              type="button"
              class="btn-icon"
              *ngIf="!completedServices[i] || expandedServices[i]">
              <i
                class="bi"
                [ngClass]="{
                  'bi-chevron-down': !expandedServices[i],
                  'bi-chevron-up': expandedServices[i]
                }"></i>
            </button>
          </div>
        </div>

        <!-- Service Content -->
        <div class="service-section-content" *ngIf="expandedServices[i]">
          <formly-field [field]="serviceField"></formly-field>

          <!-- Service level navigation buttons - for optional services that the user chose No -->
          <div
            *ngIf="serviceField.props?.['optional']"
            class="service-step-navigation mt-4">
            <div class="button-group">
              <button
                type="button"
                class="btn btn-outline-primary me-2"
                (click)="saveDraft()">
                {{
                  draftSavingInProgress
                    ? ('Saving...' | translate)
                    : ('Save Draft' | translate)
                }}
              </button>

              <button
                type="button"
                class="btn btn-primary"
                (click)="continueFromService(i)">
                {{
                  i < visibleServiceFields.length - 1
                    ? ('Continue' | translate)
                    : ('Submit' | translate)
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Hidden submit button that will be clicked programmatically -->
  <button #hiddenSubmitButton type="submit" style="display: none">
    Submit
  </button>
</div>
